import DataTable from "@/components/table/Datatable.vue";
import LoadingTable from "@/components/table/Loadingtable.vue";
import DeleteDialog from "@/components/dialog/DeleteDialog.vue";
import ToastNotification from "@/components/dialog/ToastNotification.vue";
import LoaderLoading from "@/components/loader/loader.vue";
import InfoCard from "@/components/cards/InfoCard.vue";
import TopBar from "@/components/ui/TopBar.vue";
import Sidebar from "@/components/ui/Sidebar.vue";
import Footer from "@/components/ui/Footer.vue";

export default function registerGlobalComponents(app) {
  app.component("rb-data-table", DataTable);
  app.component("rb-loading-table", LoadingTable);
  app.component("DeleteDialog", DeleteDialog);
  app.component("ToastNotification", ToastNotification);
  app.component("LoaderLoading", LoaderLoading);
  app.component("InfoCard", InfoCard);
  app.component("rb-topbar", TopBar);
  app.component("rb-sidebar", Sidebar);
  app.component("rb-footer", Footer);
}
